import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { flowNodeList, auditDetail, markList, delFlowNode, flowNodeMove } from './request';
import auditSetModel from './auditSetModel.vue';
export default {
  components: {
    auditSetModel
  },
  data() {
    return {
      data: [],
      mark: '',
      auditSetShow: false,
      columns: [{
        slots: {
          title: '审核步骤'
        },
        dataIndex: 'step',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 100
      }, {
        slots: {
          title: '节点'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '审核人'
        },
        dataIndex: 'userName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '抄送人'
        },
        dataIndex: 'ccName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 400,
        key: '6'
      }],
      customerId: '',
      markId: ''
    };
  },
  created() {
    auditDetail({
      auditFlowId: this.$route.params.id
    }).then(res => {
      console.log(res);
      let arr = markList.filter(item => item.value == res.mark);
      this.customerId = res.customerId;
      this.mark = arr[0].name;
      this.markId = res.mark;
      // this.getDataFun();
    });
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      flowNodeList({
        flowId: this.$route.params.id
      }).then(res => {
        console.log(res);
        this.data = res;
        // this.pagination.total=res.totalNum;
      });
    },
    handleAdd() {
      this.auditSetShow = true;
      this.$nextTick(() => {
        this.$refs.auditSetFrom.init(null, this.customerId, this.markId);
      });
    },
    handleEdit(val) {
      this.auditSetShow = true;
      this.$nextTick(() => {
        this.$refs.auditSetFrom.init(val, this.customerId, this.markId);
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该审核节点') + '?', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delFlowNode({
          flowNodeId: val.id
        }).then(() => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getDataFun();
        });
      });
    },
    moveFun(val, type) {
      flowNodeMove({
        flowNodeId: val.id,
        move: type
      }).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.getDataFun();
      });
    }
  }
};